import React from 'react'
import { TrendingUp } from '@mui/icons-material'
import { Chip, Theme } from '@mui/material'
import { aprToDisplay } from '@shared/conversions'

export interface PillPoolOverviewCTO {
  interestRate?: string
  indicativeInterestRate?: string
}

export function buildPills(poolBaseOverviewCTO: PillPoolOverviewCTO, theme: Theme): React.ReactElement {
  const apy =
    poolBaseOverviewCTO.interestRate && Number(poolBaseOverviewCTO.interestRate) > 0 ? (
      <Chip
        sx={{ backgroundColor: theme.palette.success.subtle, marginRight: 2 }}
        icon={<TrendingUp />}
        label={aprToDisplay(Number(poolBaseOverviewCTO.interestRate)) + '% APY'}
      />
    ) : (
      <></>
    )
  const indicativeApy =
    poolBaseOverviewCTO.indicativeInterestRate && Number(poolBaseOverviewCTO.indicativeInterestRate) != 0 ? (
      <Chip
        sx={{ backgroundColor: theme.palette.accent1.subtle, marginRight: 2 }}
        icon={<TrendingUp />}
        label={`Indicative ${aprToDisplay(Number(poolBaseOverviewCTO.indicativeInterestRate))}% APY`}
      />
    ) : (
      <></>
    )

  return (
    <>
      {apy}
      {indicativeApy}
    </>
  )
}
